import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { CarouselProvider, Slide, Slider, DotGroup } from 'pure-react-carousel';

import { CarouselDotGroup } from './styles';
import promoMedia from '../../../../theme/promoMedia';
import { QuoteTile } from '../QuoteTile/QuoteTile';

const QuoteContainer = styled.div`
    margin: -24px -24px 8px -24px;

    ${promoMedia.tablet744} {
        margin: -24px -24px 24px -24px;
    }

    ${promoMedia.desktop1440} {
        margin: -24px -24px 40px -24px;
    }

    .carousel {
        position: relative;
    }
`;

const QuoteSlide = styled.div`
    padding: 24px;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
`;

export const QuoteSectionV2 = (props) => {
    const hasData = props.data && Array.isArray(props.data);
    const totalSlides = hasData ? props.data?.length : null;
    return (
        <QuoteContainer>
            <CarouselProvider naturalSlideHeight="100%" naturalSlideWidth="100%" totalSlides={totalSlides} isPlaying={false} isIntrinsicHeight>
                <Slider>
                    {hasData &&
                        props.data
                            .filter((item) => item !== null)
                            .map((item, index) => {
                                return (
                                    <Slide index={index} key={item.id}>
                                        <QuoteSlide key={item.id}>
                                            <QuoteTile
                                                isArray={props.data.length > 1}
                                                icon={item.icon}
                                                coloredTile={item.coloredTile}
                                                bgColor={item.color?.bgColor}
                                                smallTitle={item.smallTitle}
                                                text={item.text}
                                                pdf={item.pdf}
                                                linkHref={item.linkHref}
                                                linkText={item.linkText}
                                                img={item.img}
                                                description={item.description}
                                                loadingLazy={props.loadingLazy}
                                            />
                                        </QuoteSlide>
                                    </Slide>
                                );
                            })}
                </Slider>
                {hasData && props.data.length > 1 && (
                    <CarouselDotGroup isInsideTile>
                        <DotGroup />
                    </CarouselDotGroup>
                )}
            </CarouselProvider>
        </QuoteContainer>
    );
};

QuoteSectionV2.propTypes = {
    data: PropTypes.array,
    loadingLazy: PropTypes.bool,
};
